import React from 'react';

import { IWizardStepProps, WizardContext } from '../../Wizard';
import { Container, Content, Actions, ContentText, Heading } from '../common';
import { Checkbox, CheckboxContainer } from '../common/Checkbox';
import { BENEFITS, NO_RENEWALS, SOLAR } from '../constants';
import { BenefitsIcon, NoRenewalsIcon, SolarExportMost, SolarExportLittle } from '../icons';

export class PlanType extends React.Component<IWizardStepProps> {
  static contextType = WizardContext;

  handlePlanTypeToggle = (event) => {
    this.context.saveAnswers({
      planType: event.target.value,
    });
  };
  render() {
    const { planType, solar } = this.context.answers;

    return (
      <Container>
        <Content>
          {solar ? (
            <>
              <Heading>Do you use most of the power your solar panels produce?</Heading>
              <ContentText>
                If you’re not using all of it, it’s being exported back into the grid. You may be
                earning a feed-in tariff for this.
              </ContentText>

              <CheckboxContainer>
                <Checkbox
                  label="I use most of it"
                  name="planType"
                  type="radio"
                  value={BENEFITS}
                  checked={planType === BENEFITS}
                  onChange={this.handlePlanTypeToggle}
                >
                  <SolarExportLittle />
                </Checkbox>
                <Checkbox
                  label="I export most of it"
                  name="planType"
                  type="radio"
                  value={SOLAR}
                  checked={planType === SOLAR}
                  onChange={this.handlePlanTypeToggle}
                >
                  <SolarExportMost />
                </Checkbox>
              </CheckboxContainer>
            </>
          ) : (
            <>
              <Heading>
                Would you prefer benefits lasting 12 months, or something you never have to renew?
              </Heading>
              <ContentText>
                Some of our plans offer special benefits that are assured for 12 months – like
                guaranteed rates and higher solar feed-in tariffs. With other plans you can sign up,
                and sit back. You won’t ever need to renew.
              </ContentText>

              <CheckboxContainer>
                <Checkbox
                  label="12-month benefits"
                  name="planType"
                  type="radio"
                  value={BENEFITS}
                  checked={planType === BENEFITS}
                  onChange={this.handlePlanTypeToggle}
                >
                  <BenefitsIcon />
                </Checkbox>
                <Checkbox
                  label="No need to renew"
                  name="planType"
                  type="radio"
                  value={NO_RENEWALS}
                  checked={planType === NO_RENEWALS}
                  onChange={this.handlePlanTypeToggle}
                >
                  <NoRenewalsIcon />
                </Checkbox>
              </CheckboxContainer>
            </>
          )}
          <Actions {...this.props} />
        </Content>
      </Container>
    );
  }
}
